import React from 'react';

export const PersonSvg = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 21C1 15.9791 5.07 11.9091 10.0909 11.9091H11.9091C16.93 11.9091 21 15.9791 21 21M16.4545 6.45455C16.4545 9.46701 14.0125 11.9091 11 11.9091C7.98754 11.9091 5.54545 9.46701 5.54545 6.45455C5.54545 3.44208 7.98754 1 11 1C14.0125 1 16.4545 3.44208 16.4545 6.45455Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
